import CashPointPage from './CashPointPage';

export default CashPointPage;
